import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { of } from 'rxjs';
import { Fb } from '../models/feedback.model';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  public fb: Fb | undefined = { text: 'LDGILL', status: 'text-info' };
  @Input() title: string | undefined;
  @Input() public confirmEmitter = new EventEmitter<boolean>(true);
  @Input() public body: string = '';
  @Input() public classTitle: string = 'button-ok-button-blue';
  @Input() public classButton: string = 'bg-black';
  @Input() public successMessage: string = 'Success';
  @Input() public masterStatus: any;
  @Output() public closeEmitter = new EventEmitter<boolean>();
  @Output() public statusEmitter = new EventEmitter<any>();
  @Input() public isTemplate!: boolean;
  @Input() public form!: FormGroup;
  @Input() public template!: TemplateRef<any>
  @Input() public templateSuccessMessage!: TemplateRef<any>;
  @Input() public cancelButtonText: string = 'No';
  @Input() public saveButtonText: string = 'Yes';
  callBack:any;
  isBusy!: boolean;
  isSubmitted!: boolean;
  public test: string = 'passed';

  constructor(formBuilder: FormBuilder, public modalService: NgbModal) {
     this.form = formBuilder.group({ test: [null]});
  }

  ngOnInit(): void {
  }

  public getText():string {
    return this.fb?.text ? this.fb.text : '';
  }

  public confirmYes() {
    this.isBusy = true;
    if (this.callBack) {
      this.callBack().subscribe((x:any) =>{
        this.isBusy = false;
        this.isSubmitted = true;
        this.statusEmitter.emit(x);
      }, 
      (e:any) => {
        this.isBusy = false;
        this.isSubmitted = false;
        if (e.status !== 404) {
          this.fb = {
              text: 'System Error',
              error: e
          };
        } else {
          this.fb = {
            text: 'Internal server error',
            error: e
        };
        }
      });
    } else {
      this.confirmEmitter.emit(true);
    }
  }

  public isValid(): boolean {
    return this.template && !this.form.valid
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
